import styled from '@emotion/styled';

export const MenuMainNavigation = styled.div`
  & img {
    color: white;
  }

  & .recently-added li {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
